import React from "react";

import Button from "../../Subcomponents/Button";
import Datagrid from "../../Subcomponents/Datagrid";
import SearchBar from "../../Subcomponents/Search";
import AddIcon from "@mui/icons-material/Add";
import DropDown from "./../../Subcomponents/DropDown";

// css
import cssClasses from "./SelectPreRequisite.module.css";

function SelectPreRequisite({ columns, rows, pageChanged, setSearchToken }) {
  return (
    <div className={cssClasses.mainContainer}>
      <div className={cssClasses.content}>
        <div className={cssClasses.actionWrapper}>
          {/* <div className={cssClasses.filterWrapper}>
            <div className={cssClasses.label}>
              <p>Filter by</p>
            </div>
            <div className={cssClasses.dropdownWrapper}>
              <DropDown
                style={{
                  selectedColor: "#175CD3",
                  background: "#E8F0FE",
                }}
                selectedValue={token.validity}
                onChangeSelect={(e) => {
                  console.log(e);
                  setToken({ ...token, validity: e });
                }}
                list={["All", "Live", "Upcoming", "Closed"]}
              />
            </div>
          </div> */}

          <div className={cssClasses.searchWrapper}>
            <SearchBar
              placeholder={"Search by token name"}
              search={(e) => {
                setSearchToken(e.target.value);
              }}
            //   id={id}
            />
          </div>
        </div>
        <div className={cssClasses.gridWrapper}>
          <Datagrid
            pageChanged={pageChanged}
            hideFooter={false}
            columns={columns}
            rows={rows}
          />
        </div>
      </div>
    </div>
  );
}

export default SelectPreRequisite;
